export const getLanguageCode = (language: string) => {
  if (language.startsWith('en')) {
    return 'en';
  } else {
    return 'de';
  }
};
